import { Cartesian3 } from 'cesium';

/**
 * @description: 抛物线构造函数（方程 y=-(4h/L^2)*x^2+h h:顶点高度 L：横纵间距较大者）
 * @param {*} startPosition: 起点
 * @param {*} endPosition: 终点
 * @param {*} height: 高度
 * @param {*} count: 数量
 * @return {*}
 */
const parabola = ({ startPosition, endPosition, height = 0, count = 50 }) => {
    if (!height) {
        return [
            new Cartesian3.fromDegrees(startPosition[0], startPosition[1], startPosition[2] || 0),
            new Cartesian3.fromDegrees(endPosition[0], endPosition[1], endPosition[2] || 0),
        ];
    }

    let minHeight = startPosition[2] || endPosition[2] || 0;

    let result = [];
    height = Math.max(+height, 100);
    count = Math.max(+count, 50);
    let diffLon = Math.abs(startPosition[0] - endPosition[0]);
    let diffLat = Math.abs(startPosition[1] - endPosition[1]);
    let L = Math.max(diffLon, diffLat);
    let dlt = L / count;
    if (diffLon > diffLat) {
        //base on lon
        let delLat = (endPosition[1] - startPosition[1]) / count;
        if (startPosition[0] - endPosition[0] > 0) {
            dlt = -dlt;
        }
        for (let i = 0; i < count; i++) {
            let h =
                height - (Math.pow(-0.5 * L + Math.abs(dlt) * i, 2) * 4 * height) / Math.pow(L, 2);
            let lon = startPosition[0] + dlt * i;
            let lat = startPosition[1] + delLat * i;
            let point = new Cartesian3.fromDegrees(lon, lat, h + minHeight);
            result.push(point);
        }
    } else {
        //base on lat
        let delLon = (endPosition[0] - startPosition[0]) / count;
        if (startPosition[1] - endPosition[1] > 0) {
            dlt = -dlt;
        }
        for (let i = 0; i < count; i++) {
            let h =
                height - (Math.pow(-0.5 * L + Math.abs(dlt) * i, 2) * 4 * height) / Math.pow(L, 2);
            let lon = startPosition[0] + delLon * i;
            let lat = startPosition[1] + dlt * i;
            let point = new Cartesian3.fromDegrees(lon, lat, h + minHeight);
            result.push(point);
        }
    }

    result.push(new Cartesian3.fromDegrees(endPosition[0], endPosition[1], endPosition[2] || 0))

    return result;
}

export default parabola;
